import { RouteConfig } from 'vue-router';

const ZbsjkSelect = () => import(/* webpackChunkName: "Sjzx" */  './modules/zbsjk/zbsjk-select.vue');
const ZbsjkList = () => import(/* webpackChunkName: "Sjzx" */  './modules/zbsjk/zbsjk-list.vue');
const Shujuzidian = () => import(/* webpackChunkName: "Sjzx" */  './modules/dictionary/dictionary.vue');
const ZbsjkDataExport = () => import(/* webpackChunkName: "Sjzx" */  './modules/zbsjk/data-export/data-export.vue');
const Sjkb = () => import(/* webpackChunkName: "Sjzx" */  './modules/kanban/kanban.vue');
const KanbanDaping = () => import(/* webpackChunkName: "Sjzx" */  './modules/kanban/center-transfer/daping/daping.vue');




const routers: RouteConfig[] = [
    {
        path: 'zbsjk-select',
        component: ZbsjkSelect,
    },
    {
        path: 'zbsjk-list',
        component: ZbsjkList,
    },
    {
        path: 'zbsjk-data-export',
        component: ZbsjkDataExport,
    },
    {
        path: 'shujuzidian',
        component: Shujuzidian,
    },
    {
        path: 'shujukanban',
        component: Sjkb,
    },
    {
        path: 'kanban-daping',
        component: KanbanDaping,
    },

    {
        path: '',
        redirect: 'zbsjk-select'
    }
];

export default routers;
